<template>
  <div :class="`${isForbidden ? forbiddenClass : '' } my-4 p-4 rounded-lg shadow-md`">
    <div
      v-if="!person"
      class="blink_me"
    >
      {{ personName }}
    </div>
    <div v-else>
      <div class="flex content-start mb-2">
        <div
          v-if="!isForbidden"
          :class="`rounded-full w-8 h-8 ${getBadgeColor}`"
        />
        <div class="text-xl font-bold ml-2">
          {{ person.name }}
        </div>
      </div>
      <div
        v-if="isForbidden"
        class="text-center text-4xl text-red-500 font-bold bg-gray-100"
      >
        No puedes entrar
        <div class="bg-gray-200 text-xl p-4 text-gray-500 text-left font-normal rounded-sm mb-4">
          REGLA: {{ brokenRule }}
        </div>
      </div>
      <div>
        <button
          v-if="canRegister && (!accessedToday || !uniqueRegistration)"
          :disabled="success"
          :class="`flex items-center disabled:opacity-25 disabled:pointer-events-none h-16 leading-16 ${todayPersonInside ? 'bg-red-500' : 'bg-purple-500'} text-white text-center text-xl text-bold rounded-lg my-0 z-0`"
          @click="askTemperatureAccessPoints ? isRegistering = true : sendRegister({temp: false})"
        >
          <div
            v-if="instance.exitEnabled"
            class="flex items-center pl-3"
          >
            <eva-icon
              :name="todayPersonInside ? 'log-out-outline' : 'log-in-outline'"
              fill="#FFFFFF"
              width="32"
              height="32"
            />
            <div class="ml-2">
              {{ success ? '¡Guardado!' : todayPersonInside ? 'Registrar salida' : 'Registrar ingreso' }}
            </div>
          </div>
          <div
            v-else
            class="flex items-center pl-3"
          >
            <eva-icon
              name="checkmark-circle-2-outline"
              fill="#FFFFFF"
              width="32"
              height="32"
            />
            <div
              class="ml-2"
            >
              {{ success ? '¡Guardado!' : 'Registrar ingreso' }}
            </div>
          </div>
        </button>
        <div
          v-else
        >
          <div
            v-if="uniqueRegistration && accessedToday"
            class="shadow border border-red-300 h-16 leading-16 text-xl text-center font-bold text-red-600"
          >
            Ya fue registrado HOY
          </div>
        </div>
        <a
          v-if="isAccessPoint && !canRegister"
          class="flex justify-center external shadow border border-gray-300 items-center disabled:opacity-25 disabled:pointer-events-none h-16 leading-16 text-purple-500 text-center text-xl text-bold rounded-lg my-0 z-0"
          :href="`tel:${person.phoneNumber}`"
        >
          <eva-icon
            class="cursor-pointer mr-2"
            name="phone-outline"
            fill="#6C63FF"
          />
          <div>
            Llamar
          </div>
        </a>
      </div>
      <div
        v-if="person.lastAccessRegistration"
        class="my-4"
      >
        Último registro:
        <span :class="`text-lg font-bold p-2 ${accessedToday ? 'bg-green-500 text-white' : 'bg-bluegray-500'} rounded`">{{ lastAccessDate }}</span>
      </div>
    </div>
    <div v-if="isRegistering">
      <form
        v-if="askTemperatureAccessPoints && (isAccessPoint || isInAllowedAutoregistrationTags)"
        class="mt-4 px-10 py-4 bg-white rounded"
        @submit.prevent="sendRegister({temp: true})"
      >
        <label
          for="temperature"
          class="text-lg"
        >Temperatura:</label>
        <input
          ref="temperature"
          v-model="temperature"
          class="rounded-lg w-full text-2xl border border-gray-400 focus:bg-gray-200 mb-4"
          name="temperature"
          type="number"
          step="0.1"
          min="32"
          max="42"
        >
        <div class="flex justify-between">
          <a
            class="block h-16 leading-16 text-gray-500 text-center text-xl rounded-full my-0 z-0"
            @click="reset"
          >
            Cancelar
          </a>
          <button
            type="submit"
            class="block disabled:opacity-25 disabled:pointer-events-none h-16 leading-16 bg-purple-500 text-white text-center text-xl text-bold rounded-lg my-0 z-0"
          >
            Guardar
          </button>
        </div>
      </form>
      <div
        v-else
        class="flex justify-between"
      >
        <a
          class="block h-16 leading-16 text-gray-500 text-center text-xl rounded-full my-0 z-0"
          @click="reset"
        >
          Cancelar
        </a>
        <button
          class="flex w-1/2 items-center disabled:opacity-25 disabled:pointer-events-none h-16 leading-16 bg-purple-500 text-white text-center text-xl text-bold rounded-lg my-0 z-0"
          @click="sendRegister({temp: false})"
        >
          Confirmar
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import * as axios from 'axios'
import moment from 'moment-timezone'
import { db } from '../utils/firebase'
import { mapState } from 'vuex'
export default {
  props: {
    personID: {
      default: '',
      type: String,
    },
    personName: {
      default: '',
      type: String,
    },
    personalCode: {
      default: false,
      type: Boolean,
    },
    qrInfo: {
      default: '',
      type: String,
    },
    personInstanceID: {
      default: '',
      type: String,
    },
    rules: {
      type: Object,
      default: () => {},
    },
  },
  data () {
    return {
      isRegistering: false,
      temperature: 3,
      success: false,
      person: null,
      today: null,
      brokenRule: '',
    }
  },
  computed: {
    instanceTimezone () {
      return this.instancesInfo[this.instanceID].timeZone
    },
    autoRegister () {
      if (!this.instance || !this.instance.dictionary) {
        return []
      }
      return this.instance.dictionary.parameters.autoRegister
    },
    uniqueRegistration () {
      if (!this.instance || !this.instance.dictionary) {
        return []
      }
      return this.instance.dictionary.parameters.uniqueRegistration
    },
    forbiddenClass () {
      return 'border-2 border-red-500'
    },
    isAccessPoint () {
      return this.$f7router.currentRoute.path.indexOf('access-point') > 0
    },
    getMillisLastAccessRegistration () {
      if (typeof this.person.lastAccessRegistration.toMillis !== 'function') {
        const timestamp = this.person.lastAccessRegistration
        return timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
      }
      return this.person.lastAccessRegistration.toMillis()
    },
    lastAccessDate () {
      if (this.person.lastAccessRegistration) {
        if (this.accessedToday) {
          return 'Hoy a las ' + moment.tz(this.getMillisLastAccessRegistration, this.instanceTimezone).format('hh:mm A')
        }
        return moment.tz(this.getMillisLastAccessRegistration, this.instanceTimezone).format('DD/MM - hh:mm A')
      } else {
        return ''
      }
    },
    isForbidden () {
      const brokeRule = this.testRules()
      if (brokeRule) {
        return brokeRule
      }
      return this.person && typeof this.person.forbiddenAccess !== 'undefined' && this.person.forbiddenAccess
    },
    canRegister () {
      if (this.reportedToday && !this.isRegistering && !this.isForbidden) {
        if (typeof this.person.lastReported?.riskLevel !== 'undefined' && this.person.lastReported?.riskLevel < 3) {
          return true
        }
        return !this.person.lastReported.symptomatic
      }
      return false
    },
    reportedToday () {
      if (this.person.lastReported && this.person.lastReported.timestamp) {
        return moment.tz(this.person.lastReported.timestamp.toMillis(), this.instanceTimezone).format('x') > this.today.format('x')
      }
      return false
    },
    todayPersonInside () {
      return (this.accessedToday && this.person.inside) || false
    },
    accessedToday () {
      if (this.person.lastAccessRegistration) {
        return moment.tz(this.getMillisLastAccessRegistration, this.instanceTimezone).format('x') > this.today.format('x')
      }
      return false
    },
    askTemperatureAccessPoints () {
      const value = this.instancesInfo[this.instanceID].dictionary.parameters.askTemperatureAccessPoints
      return typeof value === 'undefined' ? true : value
    },
    getBadgeColor () {
      if (this.reportedToday) {
        if (typeof this.person.lastReported.riskLevel !== 'undefined') {
          switch (this.person.lastReported.riskLevel) {
            case 0:
              return 'bg-green-500'
            case 1:
              return 'bg-yellow-500'
            case 2:
              return 'bg-orange-500'
            case 3:
              return 'bg-red-500'
            default:
              return ''
          }
        } else {
          return this.person.lastReported.symptomatic ? 'bg-red-500' : 'bg-green-500'
        }
      }
      return 'bg-purple-200'
    },
    allowedAutoRegistrationTags () {
      return this.instance.allowedAutoRegistrationTags
    },
    isInAllowedAutoregistrationTags () {
      if (this.person && this.person.tagIDs) {
        const personTagIDs = Object.keys(this.person.tagIDs)
        return this.allowedAutoRegistrationTags.some(tag => personTagIDs.includes(tag))
      }
      return false
    },
    ...mapState({
      accessInstanceID: state => state.access.instanceID,
      instancesInfo: state => state.auth.instancesInfo,
      uid: state => state.auth.uid,
    }),
    instanceID () {
      return this.personInstanceID !== '' ? this.personInstanceID : this.accessInstanceID
    },
    instance () {
      return this.instancesInfo[this.instanceID]
    },
  },
  watch: {
    isRegistering: function (val) {
      if (val && this.askTemperatureAccessPoints) {
        this.$nextTick(() => {
          if (typeof this.$refs.temperature !== 'undefined') {
            this.$refs.temperature.focus()
          }
        })
      }
    },
  },
  async mounted () {
    this.today = moment.tz(this.instanceTimezone).startOf('day')
    const personDoc = await db.collection('instances').doc(this.instanceID).collection('persons').doc(this.personID).get()
    if (personDoc.exists) {
      this.person = personDoc.data()
    }
    if (this.personalCode && this.uniqueRegistration && this.accessedToday) {
      this.$f7.dialog.alert(`El codigo QR de ${this.personName} ya ha sido usado para ingresar el dia de hoy.`, '¡Alerta!', () => {
        this.$emit('auto-registered', this.qrInfo)
      })
    } else {
      if (this.autoRegister && this.personalCode && this.canRegister) {
        await this.sendRegister({ temp: false })
      }
    }
  },
  methods: {
    testRules () {
      moment.locale('es')
      if (this.person) {
        const weekday = moment().tz(this.instanceTimezone).weekday().toString()
        for (const ruleID of Object.keys(this.rules)) {
          const rule = this.rules[ruleID]
          const tagIDs = this.person.tagIDs ? Object.keys(this.person.tagIDs) : []
          if (tagIDs.includes(rule.tagID)) {
            const days = rule.days ? Object.keys(rule.days) : []
            if (days.includes(weekday)) {
              this.brokenRule = rule.name
              return true
            }
          }
        }
      }
      return false
    },
    reset () {
      this.isRegistering = false
      this.temperature = 3
    },
    async sendRegister ({ temp }) {
      console.info({
        temperature: temp ? parseFloat(this.temperature.replace(',', '.')) : 0,
        instanceID: this.instanceID,
        registeredBy: this.uid,
        personID: this.personID,
        ...(this.instance.exitEnabled && { exit: this.todayPersonInside }),
      })
      try {
        this.$f7.dialog.preloader('Guardando...')
        const response = await axios({
          url: 'accessRegistrations/create',
          method: 'POST',
          data: {
            temperature: temp ? parseFloat(this.temperature.replace(',', '.')) : 0,
            instanceID: this.instanceID,
            registeredBy: this.uid,
            personID: this.personID,
            ...(this.instance.exitEnabled && { exit: this.todayPersonInside }),
          },
        })
        if (this.personalCode) {
          this.$emit('auto-registered', this.qrInfo)
        }
        this.$f7.dialog.close()
        console.info(response)
        this.success = true
        this.reset()
      } catch (err) {
        this.$f7.dialog.close()
        this.reset()
        console.error(err)
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.blink_me {
  animation: blinker 2s linear infinite;
}

@keyframes blinker {
  50% {
    opacity: 0;
  }
}
</style>
